module.exports = __webpack_public_path__ + "static/media/not-found-img3.5ab526f4.png";